import { booleanAttribute, DestroyRef, Directive, HostListener, inject, Input, OnInit } from '@angular/core';
import { distinctUntilChanged, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UuidExtraInfoLoggingService } from '@lx/quote-tool/shared/services';
import { DatePickerFieldDate } from '@lx/quote-tool/shared/types';

@Directive({
  standalone: true,
  selector: '[lxCourseDetailsLogging]',
})
export class CourseDetailsLoggingDirective implements OnInit {
  @Input() lxCourseDetailsLogging: string | undefined;
  @Input({ transform: booleanAttribute }) lxCourseDetailsLoggingFocusOut = false;

  private readonly uuidExtraLoggingService = inject(UuidExtraInfoLoggingService);
  private readonly valueChangeSubject = new Subject<string>();
  private readonly destroyRef = inject(DestroyRef);

  @HostListener('valueChange', ['$event'])
  onValueChange(value: string) {
    this.valueChangeSubject.next(value);
  }

  @HostListener('focusout', ['$event.target.value'])
  onFocusOut(value: string) {
    if (this.lxCourseDetailsLoggingFocusOut) {
      this.valueChangeSubject.next(value);
    }
  }

  @HostListener('dateChanged', ['$event'])
  onDateChange(value: DatePickerFieldDate) {
    this.valueChangeSubject.next(value.dateString);
  }

  ngOnInit() {
    this.valueChangeSubject
      .pipe(
        distinctUntilChanged((firstValue, secondValue) => firstValue === secondValue),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => {
        this.uuidExtraLoggingService.logCourseDetails(this.lxCourseDetailsLogging || 'unknown', value);
      });
  }
}
